export default "__VITE_ASSET__DIsUjZn0__"